<template lang="html">
  <header class="header-nav-content">
    <div class="header-nav-inner">
      <slot></slot>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderNavContent',
};
</script>

<style scoped lang="scss">
@import '@/styles/mixins/app-width';

.header-nav-content {
  flex-shrink: 0;
  height: map-get($app, 'header-height');
  margin-bottom: map-get($app, 'spacing');
  background-color: map-get($colors, 'header-background');
}

.header-nav-inner {
  @include app-width;

  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media all and (max-width: map-get($breakpoints, 'phone') - 1) {
  ::v-deep {
    .tooltip {
      &.popover {
        position: absolute;
        left: map-get($app, 'spacing') / 2;
        right: map-get($app, 'spacing') / 2;
      }
    }
  }
}
</style>
